import React, {useState} from 'react';
import TableHeader from './TableHeader';
import TableBodyRow from './TableBodyRow';

function DraggableTable({ headers, data, onReorder }) {
    const [tableData, setTableData] = useState(data);

    const handleDragStart = (event, index) => {
        event.dataTransfer.setData("dragIndex", index);
    };

    const handleDragOver = (event) => {
        event.preventDefault();
    };

    const handleDrop = (event, dropIndex) => {
        event.preventDefault();
        const dragIndex = event.dataTransfer.getData("dragIndex");

        if (dragIndex !== dropIndex) {
            let updatedData = [...tableData];
            const [draggedRow] = updatedData.splice(dragIndex, 1);
            updatedData.splice(dropIndex, 0, draggedRow);

            updatedData = updatedData.map((item, idx) => ({
                ...item,
                sort_order: {'data': idx + 1, 'classes': 'sl-min-w-10'},
            }));

            setTableData(updatedData);
            onReorder(updatedData);
        }
    };

    return (
        <table className="sl-table sl-width-100 sl-pb-32 sl-border-collapse sl-border-spacing-0">
            {tableData.length === 0 ? (
                <thead>
                    <tr>
                        <th className="sl-text-center" colSpan={headers.length}>No data for the selected item.</th>
                    </tr>
                </thead>
            ) : (
                <>
                    <TableHeader headers={headers} />
                    <tbody className="sl-bg-white sl-border sl-rounded-bottom-lg sl-border-solid sl-border-gray-200">
                    {tableData.map((rowData, index) => (
                        <TableBodyRow
                            key={rowData.id}
                            rowData={rowData}
                            index={index}
                            isDraggable={true}
                            onDragStart={handleDragStart}
                            onDragOver={handleDragOver}
                            onDrop={handleDrop}
                        />
                    ))}
                    </tbody>
                </>
            )}
        </table>

    );
}

export default DraggableTable;
